import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

/**
 * Catch-all for unmatched routes. Without this, a mistyped or stale URL (e.g. the
 * sidebar-label spellings #/admin/app-passwords, #/admin/app-logs) rendered a completely
 * blank content area that read as a crash — especially in dark mode.
 */
export function NotFound() {
	return (
		<Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, mt: 10, px: 2 }}>
			<Typography variant="h5">Page not found</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ textAlign: "center" }}>
				The address doesn&apos;t match any page in the portal. It may be a mistyped link or an outdated bookmark.
			</Typography>
			<Button component={Link} to="/home" variant="contained">
				Go to Home
			</Button>
		</Box>
	);
}
